import { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";

const EMPTY = { has_tenders: false, item_ids: [], managed_item_ids: [] };

export default function useTenderContext(businessUnitId) {
  const [state, setState] = useState({ scope: null, context: EMPTY });
  useEffect(() => {
    let cancelled = false;
    let generation = 0;
    const refresh = () => {
      const request = ++generation;
      setState({ scope: businessUnitId, context: EMPTY });
      if (!businessUnitId) return;
      axios.get("/api/purchasing/tenders/context", { params: { business_unit_id: businessUnitId } })
        .then(({ data }) => { if (!cancelled && request === generation) setState({ scope: businessUnitId, context: data?.has_tenders ? data : EMPTY }); })
        .catch(() => { if (!cancelled && request === generation) setState({ scope: businessUnitId, context: EMPTY }); });
    };
    refresh();
    window.addEventListener("purchasing-tenders-changed", refresh);
    return () => { cancelled = true; window.removeEventListener("purchasing-tenders-changed", refresh); };
  }, [businessUnitId]);
  return String(state.scope) === String(businessUnitId) ? state.context : EMPTY;
}
